import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Functions } from '@hub/common/Functions';
import { eModules } from '@hub/generated/enums';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
	selector: 'g-hyperlink',
	templateUrl: 'g-hyperlink.component.html',
})
export class AGHyperlinkComponent implements ICellRendererAngularComp {
	constructor(private router: Router) { }

    private params: any;
    public data: any;

	@Input() moduleId: number;
	@Input() isEditing: boolean = false;

    agInit(params: any): void {
        this.params = params;
        this.data = params.value;
    }

	navigate() {
		// condition for generating url for router outlets
		if (Functions.getEnumName(eModules, this.data.ModuleId, false).toLowerCase() == 'deals') {
			this.router.navigateByUrl('pa/' + this.data.Slug + "/detail");
		}

		if (Functions.getEnumName(eModules, this.data.ModuleId, false).toLowerCase() == 'tv10bookings') {
			this.router.navigateByUrl(Functions.getEnumName(eModules, this.data.ModuleId, false).toLowerCase() + '/' + this.data.Slug);
		}
		// for User
		if ((Functions.getEnumName(eModules, this.data.ModuleId, false).toLowerCase() == 'users')) {
			// TODO: fix this for slugs
			this.router.navigateByUrl(Functions.getEnumName(eModules, this.data.ModuleId, false).toLowerCase() + '/detail/' + this.data.Slug + "/administration");
		}
		if (Functions.getEnumName(eModules, this.data.ModuleId, false).toLowerCase() == 'clients') {
			this.router.navigateByUrl(Functions.getEnumName(eModules, this.data.ModuleId, false).toLowerCase() + '/' + this.data.Slug + '/detail');
		}

		if (Functions.getEnumName(eModules, this.data.ModuleId, false).toLowerCase() == 'buyers') {
			this.router.navigateByUrl(Functions.getEnumName(eModules, this.data.ModuleId, false).toLowerCase() + '/' + this.data.Slug + '/detail' );
		}

		if (Functions.getEnumName(eModules, this.data.ModuleId, false).toLowerCase() == 'packages') {
			this.router.navigateByUrl(Functions.getEnumName(eModules, this.data.ModuleId, false).toLowerCase() + '/' + this.data.Slug);
		}

		if (Functions.getEnumName(eModules, this.data.ModuleId, false).toLowerCase() == 'contacts') {
			this.router.navigateByUrl(Functions.getEnumName(eModules, this.data.ModuleId, false).toLowerCase() + '/' + this.data.Slug  + '/detail' );
		}
    }

    refresh(): boolean {
        return false;
    }
}
